<script setup>
import { ref } from 'vue';

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
  isDragging: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['open']);

const formatDate = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const mouseDownTime = ref(0);
const mouseDownPos = ref({ x: 0, y: 0 });

const handleMouseDown = event => {
  mouseDownTime.value = Date.now();
  mouseDownPos.value = { x: event.clientX, y: event.clientY };
};

const openTicket = event => {
  // Não abrir se estiver arrastando
  if (props.isDragging) return;

  // Verificar se houve movimento significativo (drag)
  const timeDiff = Date.now() - mouseDownTime.value;
  const moved =
    event &&
    (Math.abs(event.clientX - mouseDownPos.value.x) > 5 ||
      Math.abs(event.clientY - mouseDownPos.value.y) > 5);

  if (timeDiff < 200 && !moved) {
    // Emit event to open modal instead of opening new tab
    emit('open', props.ticket.id);
  }
};
</script>

<template>
  <div
    class="ticket-card p-3 rounded-lg cursor-grab active:cursor-grabbing hover:bg-slate-50 dark:hover:bg-slate-700 border border-slate-200 dark:border-slate-600 transition-colors duration-200"
    @mousedown="handleMouseDown"
    @click="openTicket"
  >
    <div class="flex items-start justify-between mb-2">
      <h4
        class="font-medium text-slate-900 dark:text-slate-100 text-sm line-clamp-2 flex-1"
      >
        {{ ticket.title }}
      </h4>
      <span
        class="text-xs text-slate-500 dark:text-slate-400 ml-2 flex-shrink-0"
      >
        #{{ ticket.id }}
      </span>
    </div>

    <p
      v-if="ticket.description"
      class="text-xs text-slate-600 dark:text-slate-300 mb-3 line-clamp-2"
    >
      {{ ticket.description }}
    </p>

    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center space-x-2">
        <span
          v-if="ticket?.status_name"
          class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
          :style="{
            backgroundColor: ticket.status_colors?.background,
            color: ticket.status_colors?.text,
          }"
        >
          {{ ticket.status_name }}
        </span>
        <span
          v-if="ticket?.priority_name"
          class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
          :style="{
            backgroundColor: ticket.priority_colors?.background,
            color: ticket.priority_colors?.text,
          }"
        >
          {{ ticket.priority_name }}
        </span>
      </div>

      <span class="text-xs text-slate-500 dark:text-slate-400">
        {{ formatDate(ticket.created_at) }}
      </span>
    </div>

    <div
      v-if="ticket.assignee"
      class="text-xs text-slate-600 dark:text-slate-300"
    >
      <span class="font-medium">Atribuído:</span> {{ ticket.assignee.name }}
    </div>
  </div>
</template>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
